import React, { useEffect } from 'react';
import { useState } from 'react';

// import { Container } from './styles';
import { useSelector } from "react-redux";
import { Redirect, useHistory } from 'react-router';
import { printToast } from '../config/global'

function usePermissions({ nomeTela }) {

  const user = useSelector((state) => state.userReducer.user);
  const history = useHistory();

  const [PERMISSOES, setPERMISSOES] = useState([])

  useEffect(() => {
    let permissoes = []
    user.contaAcesso.configAcesso.listaAutorizacoes
      .filter(element => element.nomeRole.includes(`${nomeTela}_`))
      .forEach(element => {
        permissoes.push(element.nomeRole.split('_')[1])
      })

    if (!permissoes.includes("MENU")) {
      printToast({ severity: "error", summary: "Acesso não autorizado", detail: "Consultar o administrador do sistema para liberara acesso" })
      history.push('/')
    }

    setPERMISSOES(permissoes)
  }, []);




  return PERMISSOES;
}

export default usePermissions;